import { format } from "date-fns";
import { useModelState } from "@/utils/useModelState";
import { BookingPeriodConditionTypes } from "./BookingPeriodConditionTypes/BookingPeriodConditionType";

export function MonthsBookingPeriodConditionTypeComponent({ conditionType }: MonthsBookingPeriodConditionTypeComponentProps) {

    const [,] = useModelState(conditionType.months);

    const months = {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December"
    };

    return (
        <div>
            {Object.entries(months).map(([monthKey, monthValue]) => {
                const monthNumber = parseInt(monthKey);
                return (
                    <div key={monthKey} className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id={`MonthsBookingPeriodConditionTypeComponent_${monthKey}`}
                            checked={conditionType.months.value.includes(monthNumber)}
                            onChange={e => e.target.checked ? conditionType.months.setValue([...conditionType.months.value, monthNumber]) : conditionType.months.setValue(conditionType.months.value.filter(m => m !== monthNumber))} />
                        <label className="form-check-label" htmlFor={`MonthsBookingPeriodConditionTypeComponent_${monthKey}`}>
                            {monthValue}
                        </label>
                    </div>
                );
            })}
        </div>
    );
}

export interface MonthsBookingPeriodConditionTypeComponentProps {
    conditionType: BookingPeriodConditionTypes.MonthsBookingPeriodConditionType;
}